<template>

  <b-modal size="lg" @hide="closeSearch()" ref="modal" id="modal-product-search"
           no-close-on-backdrop
           title="Buscar no Estoque" hide-footer>

    <b-row>

      <t-input cols="4" @change="changeName" v-model="form.default" label="Código"/>

      <t-input cols="4"
               v-model="form.groupProductId"
               :options="groupProductOptions"
               @change="changeGroupProduct"
               select label="Grupo"/>

      <t-input
          cols="4"
          :disabled="form.groupProductId === 0"
          v-model="form.modelId"
          :options="modelOptions"
          @change="changeModel"
          select label="Modelo"/>

      <!--      <b-col cols="3"><t-button @click="searchProducts" primary form-inline>
                    <b-icon-search class="mr-2"></b-icon-search>
                    Filtrar
                  </t-button></b-col>-->

    </b-row>


    <t-table
        @getPage="getPageSearchProduct"
        :show="checkViewListTableDefault()"
        :filtered="filtered"
        :busy="!pageListIsLoaded"
        :user-auth="userAuth"
        :items="request.content"
        :fields="fields"
        :total-pages="request.totalPages"
        :total-elements="request.totalElements"
        :container-table-style="[{'min-height':'250px'}]"
        title-items="Produtos"
        link-primary-column="productCodeLabel"
        table-bordered
        disable-actions-column
        primary-key-column="productId">

      <template #first-column="{item}">
        <b-link @click="selectProduct(item.processFlowStepRuleId)">{{ item.productCodeLabel }}</b-link>
      </template>

    </t-table>


  </b-modal>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service"

import groupProductService from "@/services/modules/product/GroupProduct.service"
import modelService from "@/services/modules/product/Model.service"

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 't-input-product-list',
  data() {
    return {
      path: "stock", //Utilizar somente quando fora do padrão
      onSending: false,
      pageProductSearch: 1,
      searchParamsProduct: new URLSearchParams(),
      filtered: false,
      form: {
        default: "",
        groupProductId: 0,
        modelId: 0,
        notGrouped: this.notGrouped,
        onlyOut: this.onlyOut,
        onlyNewProduced: this.onlyNewProduced,
        stockItemType: this.stockItemType,
      },
      fields: [
        {key: "productCodeLabel", label: "Código"},
        {key: "originCodeLabel", label: "Origem"},
        {key: "quantity", label: "Qtd. Disponível"},
        {key: "name", label: "Produto"},
        {key: "groupProduct", label: "Grupo"},
        {key: "model", label: "Modelo"},
      ],
      groupProductOptions: [],
      modelOptions: [],
    }
  },

  props: {
    show: Boolean,
    productCodeLabel: String,
    originCodeLabel: String,
    onlyOut: Boolean, //Filtrar somente saída de produtos
    notGrouped: Boolean, //Não agrupar por produto, deixar item a item para escolha
    showOriginLabel: Boolean, //Exibe o label pela Origem
    onlyNewProduced: Boolean,
    stockItemType:{
      type:[Number,String],
      default: ""
    }
  },
  watch: {

    show(v) {
      if (v) {
        this.searchProducts()
      }
    },
    productCodeLabel(v) {
      this.form.default = v
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

      await this.getModelsByGroupProductId()

      this.pageListIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    closeSearch() {
      this.$emit("onClose")
    },

    async searchProducts() {

      this.filtered = true

      Object.keys(this.form).forEach(key => {

        this.searchParamsProduct.delete(key)

        if (this.form[key] !== '' && this.form[key] !== 0) {
          this.searchParamsProduct.append(key, this.form[key])
        }

      })

      await this.getPageSearchProduct(1)


    },

    async getPageSearchProduct(pageNumber, finishLoaded = true) {

      this.pageListIsLoaded = false

      //DEVERÁ MONTAR OS PARÂMETROS DINAMICAMENTE CONFORME OS CAMPOS FOREM MARCADOS COMO DE PESQUISA
      await crudGeneral.getAll(this.path, pageNumber, this.searchParamsProduct)
          .then(response => {

            this.request = response.data

            if (finishLoaded)
              this.pageListIsLoaded = true

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          })


    },

    async getModelsByGroupProductId() {

      if (this.form.groupProductId > 0) {

        let params = new URLSearchParams()
        params.set("status", 1)
        params.set("groupProductId", this.form.groupProductId)

        await modelService.selectList(params).then((list) => {
          this.modelOptions = list
        }).catch(error => this.responseError(error))

      }

    },

    changeName() {
      this.pageListIsLoaded = false
      this.timeSearchSend(() => this.searchProducts())
      /*this.getFieldsCustomizable('model')*/
    },


    async changeGroupProduct() {
      this.form.modelId = 0 //Zera para poder consistir o valor
      await this.getModelsByGroupProductId()
      await this.searchProducts()
      /*await this.getFieldsCustomizable('groupProduct')*/
    },

    async changeModel() {
      await this.searchProducts()
      /*this.getFieldsCustomizable('model')*/
    },

    selectProduct(id) {

      if (id > 0) {
        this.$bvModal.hide('modal-product-search')
        this.$emit("onSelected", id)
      }

    }
    //--------------------------------------------------------------------------------------
  },


  async mounted() {

    this.mountedPrepare()

    await this.getPageSearchProduct(this.pageProductSearch, false)

    await this.mountedContinued()

  },

}
</script>